// check backend type for statuses explanation
export enum OrderStatus {
  New = 'new',
  Requisites = 'requisites',
  CustomerConfirm = 'customer_confirm',
  WaitingConfirmation = 'waiting_confirmation',
  TraderConfirm = 'trader_confirm',
  Completed = 'completed',
  HoldCompleted = 'hold_completed',
  Cancelled = 'cancelled',
  Error = 'error',
  Dispute = 'dispute',
}
